import useMealContext from './context';
import MealProvider from './provider';

export { MealProvider };
export default useMealContext;
